/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-real-estate-form',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './real-estate-form.component.html',
  styleUrl: './real-estate-form.component.scss',
})
export class RealEstateFormComponent implements OnInit {
  @Input() initialValue: any;
  @Input() solarAlreadySelected = false;
  @Output() formSubmit = new EventEmitter<any>();
  @Output() energyUpgradesChange = new EventEmitter<boolean>();

  realEstateForm: FormGroup;
  submitAttempted = false;

  constructor(private fb: FormBuilder) {
    this.realEstateForm = this.fb.group({
      lookingToRentOrBuy: ['', Validators.required],
      lookingToUpgrade: ['', Validators.required],
      ownFacility: [''],
      buildingOwnerWillingToSupport: [''],
      interestedInEnergyUpgrades: ['', Validators.required],
    });

    this.setupConditionalValidation();
  }

  ngOnInit(): void {
    if (this.initialValue) {
      this.realEstateForm.patchValue(this.initialValue);
    }

    // If solar support type was already selected and energy upgrades field is empty, set it to Yes
    if (
      this.solarAlreadySelected &&
      !this.realEstateForm.get('interestedInEnergyUpgrades')?.value
    ) {
      this.realEstateForm.get('interestedInEnergyUpgrades')?.setValue(true);
    }
  }

  private setupConditionalValidation() {
    this.realEstateForm
      .get('lookingToUpgrade')
      ?.valueChanges.subscribe((value) => {
        const ownFacilityControl = this.realEstateForm.get('ownFacility');
        const buildingOwnerControl = this.realEstateForm.get(
          'buildingOwnerWillingToSupport',
        );

        if (value === true) {
          ownFacilityControl?.setValidators([Validators.required]);
        } else {
          ownFacilityControl?.clearValidators();
          ownFacilityControl?.setValue('');
          buildingOwnerControl?.clearValidators();
          buildingOwnerControl?.setValue('');
        }
        ownFacilityControl?.updateValueAndValidity();
        buildingOwnerControl?.updateValueAndValidity();
      });

    this.realEstateForm.get('ownFacility')?.valueChanges.subscribe((value) => {
      const buildingOwnerControl = this.realEstateForm.get(
        'buildingOwnerWillingToSupport',
      );

      if (value === false) {
        buildingOwnerControl?.setValidators([Validators.required]);
      } else {
        buildingOwnerControl?.clearValidators();
        buildingOwnerControl?.setValue('');
      }
      buildingOwnerControl?.updateValueAndValidity();
    });

    // Watch for energy upgrades answer changes
    this.realEstateForm
      .get('interestedInEnergyUpgrades')
      ?.valueChanges.subscribe((value) => {
        // Emit true if Yes, false if No or any other value
        this.energyUpgradesChange.emit(value === true);
      });
  }

  get hasErrors(): boolean {
    return this.submitAttempted && this.realEstateForm.invalid;
  }

  public onSubmitForm() {
    if (this.realEstateForm.valid) {
      this.formSubmit.emit(this.realEstateForm.value);
    } else {
      this.submitAttempted = true;
      this.markFormGroupTouched(this.realEstateForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
    });
  }
}
